<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100">
        <div class="card bg-white shadow-sm mt-5 rounded-5 border-0">
          <div class="card-header bg-white border-0 rounded-5">
            <ul class="pills-billing-tab nav nav-pills mb-3" id="pills-billib-tab" role="tablist">
              <li class="nav-item text-sm" role="presentation">
                <button class="nav-link active" id="top_loans_tab" data-bs-toggle="pill"
                  data-bs-target="#top_loans_info" type="button" role="tab" aria-controls="top_loans_info"
                  aria-selected="true">Your Feeds</button>
              </li>
              <li class="nav-item text-sm" role="presentation">
                <button class="nav-link" id="consolidation_loan_tab" data-bs-toggle="pill"
                  data-bs-target="#consolidation_loan_info" type="button" role="tab"
                  aria-controls="consolidation_loan_info" aria-selected="false">Your Voice</button>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade show active" id="top_loans_info" role="tabpanel"
                aria-labelledby="top_loans_tab">
                <CreateFeed @trigger_component="trigger_comp" ref="create_feed" @new_report="addNewReport"/>
                <div class="table-responsive">
                  <table class="table table-striped text-xs">
                    <thead class="bg-dark text-white">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Title</th>
                        <th scope="col">Date Created</th>
                        <th scope="col">Created By</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(report, index) in reports" :key="index">
                        <th scope="row">{{ index + 1 }}</th>
                        <td v-html="report.description"></td>
                        <td>{{ report.publication_date }}</td>
                        <td>{{ report.creater.first_name }}</td>
                        <td>
                          <button class="btn btn-danger text-xxs rounded-5 mx-1 btn-sm shadow-sm"
                            @click="deleteReport(report.id)"><i class="bi bi-trash"></i> Delete</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
